import { z } from 'zod';

import { BatchCustomsStateNotificationType, BatchStatusEnum, TemplateType } from '@e-origin/shared';

export const BatchesCriteriaSchema = z.object({
  filters: z
    .object({
      searchQuery: z.string().optional(),
      isExport: z.boolean().optional().nullable(),
      templateType: z.nativeEnum(TemplateType).optional(),
      status: z.nativeEnum(BatchStatusEnum).optional(),
      customsReport: z.boolean().optional(),
      filterByUsers: z.array(z.string()).optional(),
      filterByTemplates: z.array(z.string()).optional(),
      filterByCustomers: z.array(z.string()).optional(),
      filterByNotifications: z.array(z.nativeEnum(BatchCustomsStateNotificationType)).optional(),
      integrityCheckDays: z.number().optional(),
    })
    .optional(),
  pagination: z
    .object({
      page: z.number().optional(),
      size: z.number().optional(),
    })
    .optional(),
  sorting: z
    .object({
      field: z.string(),
      direction: z.any(),
    })
    .optional(),
});

export type BatchesCriteria = z.infer<typeof BatchesCriteriaSchema>;
